module.exports = __webpack_public_path__ + "img/hr-artillery-wagon-base-shadow-3.81a6e34b.png";